var warranty = "https://shopfront-cdn.tekoapis.com/static/7d9576602ab21004.svg";

export { warranty as default };
